export enum TenantAdminNavMenuItemType {
    Connections = 0
}